<template>
    <div :class="[{ 'lb-creation-card': showControls }, cardSizeClass]">
        <div
            ref="card"
            :class="cardSizeClass"
            class="lb-card"
            @mouseover="showToolbar = true"
            @mouseleave="showToolbar = false"
        >
            <div 
                
            >
                <div
                    v-if="hasAccess && showToolbar && !editing && canEdit"
                    class="buttons has-addons toolbar"
                >
                    <a
                        class="button is-dark"
                        @click.stop="showOrEdit"
                    >
                        <span class="icon is-small">
                            <i class="fas fa-edit" />
                        </span>
                    </a>
                </div>
                <div class="lb-card-content">
                    <div class="content-header mb-1 level">
                        <div class="level-left is-shrinkable">
                            <div class="level-item is-shrinkable">
                                <p class="card-header-title title is-paddingless is-size-5 is-block">
                                    {{ $t('cuple_number') }} {{ index+1 }}
                                </p>
                            </div>
                        </div>
                        <div v-if="content.owner" class="level-right">
                            <div class="level-item">
                                <p
                                    :data-tooltip="
                                        content.owner.alias ||
                                        content.owner.name
                                    "
                                    class="
                                        image
                                        is-24x24
                                        has-tooltip-bottom
                                    "
                                >
                                    <img
                                        :src="content.owner.avatar"
                                        referrerpolicy="no-referrer"
                                        loading="lazy"
                                        class="is-rounded lb-avatar"
                                    />
                                </p>
                            </div>
                        </div>

                    </div>
                    
                    <div class="cutted-text description pb-0 mb-2" ref="description" v-if="content.description" ><div v-html="content.description"/></div>
                    <div class="showMore pt-0 has-text-weight-bold is-clickable has-text-primary" v-if="showMore" @click="expandText">{{$t('show_more')}}</div>
                    <div class="showMore pt-0 has-text-weight-bold is-clickable has-text-primary" v-if="showLess" @click="compressText">{{$t('show_less')}}</div>

                    <object-card-media
                        :show-controls="showControls"
                        :location.sync="content.location"
                        :images.sync="content.images"
                        :files.sync="content.files"
                        :embed.sync="content.embed"
                        :audio.sync="content.audio"
                        :video.sync="content.video"
                        :url.sync="content.url"
                        @zoomImage="zoomImage"
                        class="zoom-cursor"
                    />
                    
                    <div class="py-2 has-text-centered">
                        <i class="mdi mdi-3rem mdi-arrow-up-down-bold-outline" ></i>
                    </div>

                    <div class="cutted-text description2 pb-0 mb-2" ref="description2" v-if="content.pairWith.description" ><div v-html="content.pairWith.description"/></div>
                    <div class="showMore pt-0 has-text-weight-bold is-clickable has-text-primary" v-if="showMore2" @click="expandText2">{{$t('show_more')}}</div>
                    <div class="showMore pt-0 has-text-weight-bold is-clickable has-text-primary" v-if="showLess2" @click="compressText2">{{$t('show_less')}}</div>

                    <object-card-media
                        :show-controls="showControls"
                        :location.sync="content.pairWith.location"
                        :images.sync="content.pairWith.images"
                        :files.sync="content.pairWith.files"
                        :embed.sync="content.pairWith.embed"
                        :audio.sync="content.pairWith.audio"
                        :video.sync="content.pairWith.video"
                        :url.sync="content.pairWith.url"
                        @zoomImage="zoomImage"
                        class="zoom-cursor"
                    />
                    
                </div>
            </div>
            <project-modal-share
                v-if="showShareModal"
                :content="content"
                @close="showShareModal = false"
            ></project-modal-share>
        </div>
    </div>
</template>

<script>
import ObjectCardToolbar from '@/components/ObjectCardToolbar';
import ObjectCardRelatedToolbar from '@/components/ObjectCardRelatedToolbar';
import ObjectCardMedia from '@/components/ObjectCardMedia';
import ObjectCardRelated from '@/components/ObjectCardRelated';
import ObjectCardTags from '@/components/ObjectCardTags';
import AppCollapsableText from '@/components/AppCollapsableText';
import vClickOutside from 'v-click-outside';
import InputRichText from '@/components/InputRichText';
import _ from 'underscore';
import { likeObject } from '@/services/API';
import ProjectModalShare from '@/components/ProjectModalShare';
export default {
    name: 'ObjectCardMemory',
    components: {
        ObjectCardToolbar,
        ObjectCardMedia,
        ObjectCardRelated,
        ObjectCardRelatedToolbar,
        ObjectCardTags,
        InputRichText,
        AppCollapsableText,
        ProjectModalShare,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
        model: {
            type: Object,
            default() {
                return {};
            },
        },
        index: {
            type: Number,
            default: 0
        },
        isCreation: { type: Boolean, default: false },
        isEdition: { type: Boolean, default: false },
        modalOpened: { type: Boolean, default: false },
        showAnswers: {
            type: Boolean,
            default: false,
        },
        hasLocation: {
            type: Boolean,
            default: false,
        },
        editing: {
            type: Boolean,
            default: false,
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showToolbar: false,
            showEdition: false,
            showShareModal: false,
            resizeObserver: new ResizeObserver((entries) => {
                for (let entry of entries) {
                    this.$emit('resize');
                }
            }),
            showMore: false,
            showLess: false,
            showMore2: false,
            showLess2: false,
        };
    },
    computed: {
        contentURL() {
            return window.location.href;
        },
        relatedContent: {
            get() {
                const relatedObjects = _.pluck(this.model.related, 'name');
                return _.pick(this.content, relatedObjects);
            },
            set() {
                console.log('here set related content');
            },
        },
        mediaContent() {
            const mediaObjects = _.pluck(this.model.media, 'name');
            return _.pick(this.content, mediaObjects);
        },
        hasAccess() {
            if (this.isCreation) {
                return true;
            }
            return this.content.accessLevel == 'administrator';
        },
        showControls() {
            return this.isEdition || this.isCreation;
        },
        cardSize() {
            return this.$store.getters['Project/cardSize'];
        },
        cardSizeClass() {
            return `is-${this.cardSize.toLowerCase()}`;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        canAddComment() {

            if (this.isLoggedIn && this.$store.getters.canCommentInObjects && this.$route.name!="project-view") {
                return true;
            }
            return false;
        },
        titlePlaceholder() {
            // console.log(this.$store.getters.projectContent)
            if (
                this.$store.getters.project.type == 'treasurehunt' &&
                this.$store.getters.projectContent.length == 1
            ) {
                return 'creation.treasurehunt_title_hint';
            }
            return 'creation.title_hint';
        },
        descriptionPlaceholder() {
            // console.log(this.$store.getters.projectContent)
            if (
                this.$store.getters.project.type == 'treasurehunt' &&
                this.$store.getters.projectContent.length == 1
            ) {
                return this.$t('creation.treasurehunt_description_hint');
            }
            return '';
        },
        canOpenObject(){
            return this.$store.getters.project.format == "PROJECT_TYPE_WALL";
        },
    },
    mounted() {
        // console.log(this.content)
        this.resizeObserver.observe(this.$refs.card);
        if (this.hasLocation && this.isCreation && !this.content.location) {
            this.$emit('addElement', 'location');
        }
        if(this.$refs.description){
            if(this.$refs.description.scrollHeight>this.$refs.description.offsetHeight){
                this.showMore=true;
                this.$refs.description.classList.remove("mb-2");
            }
        }
        if(this.$refs.description2){
            if(this.$refs.description2.scrollHeight>this.$refs.description2.offsetHeight){
                this.showMore2=true;
                this.$refs.description2.classList.remove("mb-2");
            }
        }
    },
    destroyed() {
        this.resizeObserver.disconnect();
    },
    methods: {
        expandText(){
            this.$refs.description.classList.remove("cutted-text");
            this.showMore = false;
            this.showLess = true;
        },
        compressText(){
            this.$refs.description.classList.add("cutted-text");
            this.showMore = true;
            this.showLess = false;
        },
        expandText2(){
            this.$refs.description2.classList.remove("cutted-text");
            this.showMore2 = false;
            this.showLess2 = true;
        },
        compressText2(){
            this.$refs.description2.classList.add("cutted-text");
            this.showMore2 = true;
            this.showLess2 = false;
        },
        enableEdition() {
            this.$emit('edit');
            this.showEdition = true;
        },
        onClickOutside(e) {
            if (!this.modalOpened) {
                if (_.isEmpty(this.content)) {
                    return this.$emit('cancel');
                }
                if (this.showControls) {
                    e.type != 'touchstart' && this.$emit('clickOutside');
                }
            }
        },
        openModal(e) {
            this.$emit('addElement', e.type);
        },
        openModalEdit(e) {
            this.showControls && this.$emit('addElement', e);
        },
        async toggleLike() {
            if (this.isLoggedIn) {
                let likeResult = await likeObject(this.content._id);
                this.content.liked = likeResult.data.liked;
                this.content.likes = likeResult.data.likes;
            }
        },
        validateAndSave() {
            //TODO: validate also type
            const requiredMedia = _.chain(this.model.media)
                .filter((media) => media.required)
                .pluck('name')
                .concat()
                .value();
            const requiredProps = _.chain(this.model)
                .pick((value, key) => {
                    return value.required;
                })
                .keys()
                .value();
            const requiredFields = requiredProps.concat(requiredMedia);
            const isValid = _.chain(requiredFields)
                .every((prop) => _.has(this.content, prop))
                .value();
            if (isValid) {
                this.$emit('save');
            } else {
                alert(this.$t('Error.MISSING_REQUIRED_FIELDS'));
            }
        },
        showOrEdit(){
            if(this.editing){
                return;
            }
            if(this.hasAccess){
                // console.log("editing object",this.content.title)
                this.$emit('edit',this.content);
            }
        },
        zoomImage(e){
            this.$emit('zoomImage',e);
        },
        openObject(object) {
            if(this.canOpenObject && !this.editing){
                this.$emit('show', object);
            }
            
            // console.log("opening object");
            
            /*this.activeObject = _.findWhere(this.filteredItems, {
                _id: object._id,
            });
            // this.activeMarker = object;
            this.showObjectModal = true;*/
        },
    },
};
</script>

<style scoped>
@import '../assets/css/object-card.css';

.owner-image{
    position: absolute;
    top: 1rem;
    right: 1.5rem;
}
.mdi-3rem{
    font-size: 3rem;
}
.zoom-cursor{
    cursor: zoom-in;
}
.card-header-title:hover{
    color: #363636;
}
</style>
